// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFullscreenOutlinedSvg from "@fishx/icons-svg/es/asn/PFullscreenOutlined";
import FishxIcon from '../components/FishxIcon';

var PFullscreenOutlined = function PFullscreenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFullscreenOutlinedSvg
  }));
};

PFullscreenOutlined.displayName = 'PFullscreenOutlined';
export default React.forwardRef(PFullscreenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFullscreenOutlined.js
// module id = 3431
// module chunks = 0